/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NatureFxSparkleA2Icon16Light } from './NatureFxSparkleA2Icon16Light';
import { NatureFxSparkleA2Icon16Regular } from './NatureFxSparkleA2Icon16Regular';
import { NatureFxSparkleA2Icon16Solid } from './NatureFxSparkleA2Icon16Solid';
import { NatureFxSparkleA2Icon20Light } from './NatureFxSparkleA2Icon20Light';
import { NatureFxSparkleA2Icon20Regular } from './NatureFxSparkleA2Icon20Regular';
import { NatureFxSparkleA2Icon20Solid } from './NatureFxSparkleA2Icon20Solid';
import { NatureFxSparkleA2Icon24Regular } from './NatureFxSparkleA2Icon24Regular';
import { NatureFxSparkleA2Icon24Solid } from './NatureFxSparkleA2Icon24Solid';
import { NatureFxSparkleA2Icon32Regular } from './NatureFxSparkleA2Icon32Regular';
import { NatureFxSparkleA2Icon64Regular } from './NatureFxSparkleA2Icon64Regular';
var sizes = {
    16: {
        light: NatureFxSparkleA2Icon16Light,
        regular: NatureFxSparkleA2Icon16Regular,
        solid: NatureFxSparkleA2Icon16Solid,
    },
    20: {
        light: NatureFxSparkleA2Icon20Light,
        regular: NatureFxSparkleA2Icon20Regular,
        solid: NatureFxSparkleA2Icon20Solid,
    },
    24: {
        regular: NatureFxSparkleA2Icon24Regular,
        solid: NatureFxSparkleA2Icon24Solid,
    },
    32: {
        regular: NatureFxSparkleA2Icon32Regular,
    },
    64: {
        regular: NatureFxSparkleA2Icon64Regular,
    },
};
export var NatureFxSparkleA2Icon = forwardRef('NatureFxSparkleA2Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
